import { formatValue } from '../../glossary/formatValue';

export const currency = (v: number) => formatValue(v, 'currency');

// Display the global 1-based month number from the start of LTC (not
// month-in-year), so "Month 20" stays "Month 20" rather than wrapping
// back to "Month 8".
export const monthDisplay = (monthIndex: number): number => monthIndex + 1;
